import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { useProfile } from 'src/common/api-clients/thirdweb/useProfile'
import Button from 'src/common/ui-kit/Button/Button'
import Icon from 'src/common/ui-kit/Icon/Icon'
import { walletRoutes } from 'src/pages/WalletPage/wallet-routes'
import {
  ConnectButton,
  ConnectButtonProps,
  useActiveAccount,
} from 'thirdweb/react'

const ConnectWalletDesktop: React.FC<ConnectButtonProps> = ({ ...props }) => {
  const account = useActiveAccount()
  const navigate = useNavigate()
  const { data: profile } = useProfile()

  const clicksCounterRef = useRef(0)
  const handleProfileClick = () => {
    navigate(walletRoutes.path)
    clicksCounterRef.current += 1
  }

  return account ? (
    <Button
      className='py-2 px-4 flex items-center gap-2'
      variant='outlined'
      onClick={handleProfileClick}
    >
      <Icon className='w-5' name='wallet' />
      {profile.nickname}
    </Button>
  ) : (
    <ConnectButton
      connectButton={{
        style: { height: 40 },
      }}
      {...props}
    />
  )
}

export default ConnectWalletDesktop
